module.exports = __webpack_public_path__ + "img/taili10.76f88af8.jpg";